import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { AuthWebService } from 'app/services/authweb.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CarrierService } from 'app/services/carrier.service';
import { PopupService } from 'app/services/shared/popup.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';


declare var $: any;

@Component({
  selector: 'trip',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.css']
})
export class TripComponent implements OnInit {

  tripForm: FormGroup;
  public paxList: UploadFile[] = [];
  uploads: any = [];
  uploadFwds: any = [];
  uploadRtns: any = [];
  compList: any = [];
  message: string = "Processing, please wait...";
  isLoading: boolean = false;
  maxMB: any;
  allowedFileTypes: any;
  lastName: string;
  allowedFileSize: any;
  hasTrip: boolean = true;
  isFreight: boolean = true;
  docTypeId: number = 0;
  @Input('dataCtrl') dataCtrl: any;

  constructor(private documentService: DocumentsServiceService, private documenttypeService: DocumenttypeService,    
    private formBuilder: FormBuilder,
    private authWebService: AuthWebService, private sanitizer: DomSanitizer,
    private confirm: PopupService,private toastService:ToastNotificationService,

     private utility: UtilityServiceService, private ref: ChangeDetectorRef, private notice: ToastrService) {
    
  }

  ngOnInit() {
    this.maxMB = (this.authWebService.userData) ? this.authWebService.userData.Configurations.find(p => p.Code == 'MaxUploadMB1').Value:0;
    this.lastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.allowedFileSize = this.authWebService.userData.Configurations.find(p => p.Code == 'MaxUploadMB1');
    this.allowedFileTypes = this.authWebService.userData.Configurations.find(p => p.Code == 'UploadDocTypes1');
    this.initFreight();
    ////console.log('dataCtrl', this.dataCtrl);
    const code = (this.isFreight) ? 'DocTypeFreightUpload' : 'DocTypePaxUpload';
    this.docTypeId = (this.authWebService.userData) ? this.authWebService.userData.Configurations.find(p => p.Code == code).Value : 0;
    //console.log('DocTypeId', this.docTypeId);
    ////console.log('DocTypeId', this.authWebService.userData.Configurations.find(p => p.Code == code).Value)
    this.initForm();
  }

  onSwitchOnOrOff = (state = false) => {
    this.isLoading = state;
  }

  //Form part
  initForm() {
    this.tripForm = this.formBuilder.group({
     
      trips: this.formBuilder.array([this.newTrip()]),
      
    });
   
  }

  get trips(): FormArray {
    return this.tripForm.get("trips") as FormArray
  }

  newTrip(): FormGroup {
    return this.formBuilder.group(
      (this.isFreight) ? {
        FType: 1,
        FMass: 0,
        FCat: '',
        FUploads: [],
        RType: 2,
        RMass: 0,
        RCat: '',
        RUploads: [],
        tripNum: 0
      } :
        {
          FType: 1,
          FNPax: 0,
          FUploads: [],
          RType: 2,
          RNPax: 0,
          RUploads: [],
          tripNum: 0
        }
    );
  }

  addTrip() {
    this.trips.push(this.newTrip());
  }

  removeTrip(i: number) {
    this.trips.removeAt(i);
  }

  onSubmit() {
    ////console.log(this.tripForm.value);
    
    this.transform();
  }

  //End Form part

  process = () => {
    alert('Uploaded pax list');
  }

  onShow = () => {
    this.paxList = [];
    $("#Manager").modal();
  }
  onClose = () => {   
    $("#Manager").modal('hide');
  }

  //Drap and drop files

  processdroppedFile(entry: UploadFile) {
  

    return new Promise((resolve, reject) => {

      if (entry.fileEntry.isFile) {
        const fileEntry = entry.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          const reader = new FileReader();

          reader.onload = () => {            
            resolve(
              [{
                    filestream: reader.result.toString().split(',')[1],
                    filename : file.name,
                    filetype : file.type,
                    filedescription : 'Pax list upload',
                    filesize: file.size,
              }]
            );
          };
          reader.onerror = err => reject(err);

          reader.readAsDataURL(file);
        });
      }
  });
}

  public dropped(event: UploadEvent,index,key=1) {
    this.paxList = event.files;
    //this.uploads.push(this.paxList);
    if (key == 1) {
      //this.uploadFwds[index] = this.paxList;
      this.processdroppedFile(this.paxList[0]).then(res => {
        this.uploadFwds[index] = res;        
      });

    }
    else {
      //this.uploadRtns[index] = this.paxList;
      this.processdroppedFile(this.paxList[0]).then(res => {
        this.uploadRtns[index] = res;
      });
    }
      

    

    //this.paxList = [];
    //for (const droppedFile of event.files) {
    //  ////console.log('DroppedFile :', droppedFile);
    //  // Is it a file?
    //  if (droppedFile.fileEntry.isFile) {
    //    const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
    //    fileEntry.file((file: File) => {

    //      // Here you can access the real file
    //      //console.log(droppedFile.relativePath, file);
    //      //this.uploads.push(file.name);
    //      //this.doUpload(file);
          
    //      /**
    //      // You could upload it like this:
    //      const formData = new FormData()
    //      formData.append('logo', file, relativePath)
 
    //      // Headers
    //      const headers = new HttpHeaders({
    //        'security-token': 'mytoken'
    //      })
 
    //      this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
    //      .subscribe(data => {
    //        // Sanitized logo returned from backend
    //      })
    //      **/

    //    });
    //  } else {
    //    // It was a directory (empty directories are added, otherwise only files)
    //    const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
    //    //console.log('Uploaded folder: ', droppedFile.relativePath, fileEntry);
    //  }
     
    //}
  }

  public fileOver(event) {
   // //console.log('From FileOver:',event);
  }

  public fileLeave(event) {
    ////console.log('From FileLeave:',event);
  }

  //Upload file

  doUpload(fileObj: any, attrs:any = {}) {
    
    ////console.log('FileObj:', fileObj);
    if (fileObj) {
      
      let result = this.checkFileType(fileObj.name);
      
      const reader = new FileReader();

      
        if (result != -1) {

          let sizeresult = this.checkFileSize(fileObj.size);

          if (sizeresult != -1) {
            //this.ref.detectChanges();
            
            let uploads = [];
            reader.removeEventListener
            const file_data = new FormData();
            reader.onload = () => {
              
              file_data.append('filestream', reader.result.toString().split(',')[1]);
              file_data.append('filename', fileObj.name);
              file_data.append('filetype', fileObj.type );
              file_data.append('filedescription', 'Pax list upload');
              file_data.append('filesize', fileObj.size);
              file_data.append('lastname', this.lastName);
              file_data.append('filedate', new Date().toLocaleString());
              file_data.append('carrierid', this.dataCtrl.compliance.carrierId);
              file_data.append('carrierName', this.dataCtrl.compliance.carrierName);
              file_data.append('permitid', this.dataCtrl.compliance.permitKey);
              file_data.append('doctypid', `${this.docTypeId}`);
              file_data.append('calday', this.dataCtrl.cal_date);
              file_data.append('tripCat', attrs.tripCat);
              file_data.append('tripMass', attrs.tripMass);
              file_data.append('tripNPax', attrs.tripNPax);
              file_data.append('tripType', attrs.tripType);
              file_data.append('tripNum', attrs.tripNum);//To be changed

              this.uploads.push(file_data);
              //uploads.push(
              //  {
              //    filestream: reader.result.toString().split(',')[1],
	             //   filename : fileObj.name,
              //    filetype : fileObj.type,
              //    filedescription : 'Pax list upload',
              //    filesize: fileObj.size,
              //    tripCat: attrs.tripCat,
              //    tripMass: attrs.tripMass,
              //    tripNPax: attrs.tripNPax,
              //    tripType: attrs.tripType,
              //  }
              //);
              //this.onSwitchOnOrOff(true);
              //this.documentService.uploadPaxList(file_data).subscribe(resp => {
              //  //console.log('Response:', resp);
              //  this.onSwitchOnOrOff();
              //}, error => {
              //  //console.log('Error :', JSON.stringify(error));
              //  this.onSwitchOnOrOff();
              //});

              //var object = {};
              //file_data.forEach((value, key) => { object[key] = value });
              //var json = JSON.parse(object);
              ////console.log('File Data:', object );
              ////console.log('File Data:', uploads);
            };
            reader.readAsDataURL(fileObj);
            
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, 'File Upload Failed, Please try again.');


          }

        }
        else {
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
          this.toastService.error(`Only these file types are allowed: PDF`, 'File Upload Failed, Please try again.')
        }

      //}

    }

  }

  checkFileType(fileName: string) {
    // from the file name derive the extension
    //let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
    let fileTypesArray = this.allowedFileTypes.Value.toString().split(',');
    //check if file type is 
    let ext = fileName.split('.')[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }

  checkFileSize(fileSize: number) {
    // get the maximum file size 
    //let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
    let maxAllowedSize = this.allowedFileSize.Value; //it is in MB
    let document_sizeMB = (fileSize / 1000000);
    if (document_sizeMB <= maxAllowedSize)
      return 1;
    else return -1;
   
  }

  changeState = (event) => {
    //console.log('Checkbox : ', event.target.checked);
    this.hasTrip = event.target.checked;
  }

  public processFiles() {
    this.uploads = this.transform();
    let rCount = 0;
    let fCount = 0;
    let rSCount = 0;
    let fSCount = 0;
    let records = [];
    //const countAll = 0;
    let countCtrl = 0;
    this.compList = [];
    this.uploads.forEach(item => {
      const attrs = {
        tripCat: item.tripCat,
        tripMass: item.tripMass,
        tripNPax: item.tripNPax,
        tripType: item.tripType,
        tripNum: item.tripNum
      };
      this.setData(item,attrs)

    });

    ////console.log('Item : ', this.compList);
    this.readFile(this.compList);
    //const file_data = new FormData();
    //file_data.append('uploads', this.compList);
    this.onSwitchOnOrOff(true);
    const countAll = this.compList.length;
    this.compList.forEach(upload => {
      countCtrl++;
      this.documentService.uploadPaxList(upload).subscribe(resp => {
        //console.log('Response:', resp);
        this.onSwitchOnOrOff();
        
      }, error => {
        //console.log('Error :', JSON.stringify(error));
        this.onSwitchOnOrOff();
      });
    });
    if (countAll == countAll) {
      //this.tripForm.patchValue({trips:[]});
      this.initForm();
      this.uploadFwds = [];
      this.uploadRtns = [];

    }

  }



  setData(fileObj: any, attrs: any = {}) {

    ////console.log('FileObj:', fileObj);
    if (fileObj.tripUploads) {

      let result = this.checkFileType(fileObj.tripUploads.filename);

     


      if (result != -1) {

        let sizeresult = this.checkFileSize(fileObj.tripUploads.filesize);

        if (sizeresult != -1) {
          //this.ref.detectChanges();

          
          //const file_data = {
          //  'filestream': fileObj.tripUploads.filestream,
          //  'filename': fileObj.tripUploads.filename,
          //  'filetype': fileObj.tripUploads.filesize.filetype,
          //  'filedescription': 'Pax list upload',
          //  'filesize': fileObj.tripUploads.filesize,
          //  'lastname': this.lastName,
          //  'filedate': new Date().toLocaleString(),
          //  'carrierid': this.dataCtrl.compliance.carrierId,
          //  'carrierName': this.dataCtrl.compliance.carrierName,
          //  'permitid': this.dataCtrl.compliance.permitKey,
          //  'doctypid': `${this.docTypeId}`,
          //  'calday': this.dataCtrl.cal_date,
          //  'tripCat': attrs.tripCat,
          //  'tripMass': attrs.tripMass,
          //  'tripNPax': attrs.tripNPax,
          //  'tripType': attrs.tripType,
          //  'tripNum': attrs.tripNum
          //}
          const file_data = new FormData();
         
            file_data.append('filestream', fileObj.tripUploads.filestream);
            file_data.append('filename', fileObj.tripUploads.filename);
            file_data.append('filetype', fileObj.tripUploads.filesize.filetype);
            file_data.append('filedescription', 'Pax list upload');
            file_data.append('filesize', fileObj.tripUploads.filesize);
            file_data.append('lastname', this.lastName);
            file_data.append('filedate', new Date().toLocaleString());
            file_data.append('carrierid', this.dataCtrl.compliance.carrierId);
            file_data.append('carrierName', this.dataCtrl.compliance.carrierName);
            file_data.append('permitid', this.dataCtrl.compliance.permitKey);
            file_data.append('doctypid', `${this.docTypeId}`);
            file_data.append('calday', this.dataCtrl.cal_date);
            file_data.append('tripCat', attrs.tripCat);
            file_data.append('tripMass', attrs.tripMass);
            file_data.append('tripNPax', attrs.tripNPax);
            file_data.append('tripType', attrs.tripType);
            file_data.append('tripNum', attrs.tripNum);//To be changed

          this.compList.push(file_data);
           
          

        }
        else {
          // this.uploader.nativeElement.value = ''
          let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
          this.toastService.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, 'File Upload Failed, Please try again.');


        }

      }
      else {
        let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
        this.toastService.error(`Only these file types are allowed: PDF`, 'File Upload Failed, Please try again.')
      }

      //}

    }

  }



  public processFiles1() {
    this.uploads.forEach(item => {
      for (const droppedFile of item) {
        if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          // Here you can access the real file
          ////console.log(droppedFile.relativePath, file);
          //this.uploads.push(file.name);
          this.doUpload(file);


        });
      } 
      }
      ////console.log('Uploaded files: ', item);
    });
    //for (const droppedFile of event.files) {
    //  ////console.log('DroppedFile :', droppedFile);
    //  // Is it a file?
    //  if (droppedFile.fileEntry.isFile) {
    //    const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
    //    fileEntry.file((file: File) => {

    //      // Here you can access the real file
    //      //console.log(droppedFile.relativePath, file.name);
    //      //this.uploads.push(file.name);
    //      this.doUpload(file);


    //    });
    //  } else {
    //    // It was a directory (empty directories are added, otherwise only files)
    //    const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
    //    //console.log('Uploaded folder: ', droppedFile.relativePath, fileEntry);
    //  }
    //  return;
    //}
  }



   public processFiles2() {
    this.uploads = this.transform();
    let rCount = 0;
    let fCount = 0;
    let rSCount = 0;
    let fSCount = 0;
     let records = [];
     const countAll = this.uploads.length;
     let countCtrl = 0;
    this.uploads.forEach(item => {
      countCtrl++;
      (item.tripType == 1) ? fSCount++ : rSCount++;
      //if (item.tripUploads) { 
      //for (const droppedFile of item.tripUploads) {
      if (item.tripUploads) {
        const droppedFile = item.tripUploads
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file((file: File) => {

            // Here you can access the real file
            ////console.log(droppedFile.relativePath, file);
            //this.uploads.push(file.name);
            const attributes = {
              tripCat: item.tripCat,
              tripMass: item.tripMass,
              tripNPax: item.tripNPax,
              tripType: item.tripType,
              tripNum: item.tripNum

            };
            //this.doUpload(file, attributes);
            this.preprocess(file, attributes).then(resp => {
              records.push(resp);

              if (countAll === countCtrl) {
              //  //console.log(`Number of records = ${records.length}`);
              //  let count = 0;
              //  records.forEach(item => {
              //    var object = {}; count++;
              //    item.forEach((value, key) => { object[key] = value });
              //    //var json = JSON.parse(object);
              //    //console.log(`Item ${count}:`, object);

              //  });
                //console.log(`countAll = ${countAll} |countCtrl = ${countCtrl}`);
                    this.readFile(records);
                }
                //this.readFile(records);
            });
            //if (record) {
            //  records.push(record);
            

            
            //}


          });
        }
        //}
      }
      else {
        if (item.tripType == 1)
          rCount++;
        else
          fCount++;
      }
        //this.notice.info("Please provide at least one file to upload.",'Compliance trip');
      ////console.log('Uploaded files: ', item);
      
    });
      

    //console.log('rCount : ', rCount);
    //console.log('fCount : ', fCount);

    //console.log('rSCount : ', rSCount);
    //console.log('fSCount : ', fSCount);
  }


  transform = () => {
    //console.log('dataCtrl', this.dataCtrl);
    const trips = [];
    this.tripForm.value.trips.forEach(item => {
      if (this.isFreight) {
        trips.push({
          tripType: item.FType,
          tripMass: item.FMass,
          tripCat: item.FCat,
          tripUploads: item.FUploads,
          tripNPax: 0,
          tripNum: item.tripNum

        });

        trips.push({
          tripType: item.RType,
          tripMass: item.RMass,
          tripCat: item.RCat,
          tripUploads: item.RUploads,
          tripNPax: 0,
          tripNum: item.tripNum
        });
      } else {
        trips.push({
          tripType: item.FType,
          tripMass: 0,
          tripCat: '',
          tripUploads: item.FUploads,
          tripNPax: item.RNPax,
          tripNum: item.tripNum

        });

        trips.push({
          tripType: item.RType,
          tripMass: 0,
          tripCat: '',
          tripUploads: item.RUploads,
          tripNPax: item.RNPax,
          tripNum: item.tripNum
        });
      }

    });

    ////console.log('Trip', trips);
    return trips;
  }

  initFreight = () => {
    this.isFreight = !(this.dataCtrl.compliance.freight_passenger_ind == 1);
  }


  //Bulk submission

  preprocess(fileObj: any, attrs: any = {}) {

    ////console.log('FileObj:', fileObj);

    return new Promise((resolve, reject) => {
    if (fileObj) {

      let result = this.checkFileType(fileObj.name);

      const reader = new FileReader();


      if (result != -1) {

        let sizeresult = this.checkFileSize(fileObj.size);
        const file_data = new FormData();
        if (sizeresult != -1) {
          //this.ref.detectChanges();

          let uploads = [];
          reader.removeEventListener
          
          reader.onload = () => {

            file_data.append('filestream', reader.result.toString().split(',')[1]);
            file_data.append('filename', fileObj.name);
            file_data.append('filetype', fileObj.type);
            file_data.append('filedescription', 'Pax list upload');
            file_data.append('filesize', fileObj.size);
            file_data.append('lastname', this.lastName);
            file_data.append('filedate', new Date().toLocaleString());
            file_data.append('carrierid', this.dataCtrl.compliance.carrierId);
            file_data.append('carrierName', this.dataCtrl.compliance.carrierName);
            file_data.append('permitid', this.dataCtrl.compliance.permitKey);
            file_data.append('doctypid', `${this.docTypeId}`);
            file_data.append('calday', this.dataCtrl.cal_date);
            file_data.append('tripCat', attrs.tripCat);
            file_data.append('tripMass', attrs.tripMass);
            file_data.append('tripNPax', attrs.tripNPax);
            file_data.append('tripType', attrs.tripType);
            file_data.append('tripNum', attrs.tripNum);//To be changed

            //this.uploads.push(file_data);
            resolve(file_data);
            
          };
          reader.onerror = err => reject(err);
          reader.readAsDataURL(fileObj);

          //return file_data;
        }
       

      }

    }

    });

  }


  readFile(file:any) {
        //console.log(`Number of records = ${file.length}`);
        let count = 0;
        file.forEach(item => {
                  var object = {}; count++;
                  //item.forEach((value, key) => { object[key] = value });                  
                  //console.log(`Item ${count}:`, item);

                });
              
  }




}
